import { WhiteBox, FoodsIcon } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    ssqTitle: string;
};
export const NoScore = (props: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <WhiteBox>
            <Stack flexDirection={"row"} gap={theme.spacing(1.5)} padding={theme.spacing(2)} alignItems={"center"}>
                <FoodsIcon size={4} icon={"warning"} />
                <Typography variant="body-medium">
                    {t("scores.empty_scores", "First complete your Questionnaire {{title}}", {
                        title: props.ssqTitle,
                    })}
                </Typography>
            </Stack>
        </WhiteBox>
    );
};
